import React, { useState ,useEffect } from "react";
import { FaUser,FaPhone, FaEnvelope,FaShieldAlt, FaCheckCircle, FaUserCheck, FaUserTimes, FaBuilding, FaMapMarkerAlt,  FaFileInvoice, FaImage,  FaIdCard, FaFilePdf,FaSearch,FaPlus,FaTimes
} from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";
import { FaHouse } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { MdAccountBalance } from "react-icons/md";
import { MdOutlineAccountCircle } from "react-icons/md";
import { BsBank } from "react-icons/bs";

import axios from 'axios'
import toast from "react-hot-toast";


function Chatbot_Suggestion({token}) {
  const[fetchWeb,setFetchWeb] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
      const [showForm, setShowForm] = useState(false);

const fetchSuggestion = async () => {
  try {
    const res = await axios.get("https://api.krimotion.in/fetch-chatbot-suggestion",
       {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }
    )
    const result = res.data;

    setFetchWeb(result);
  } catch (error) {
    console.log(error);
  }
};

   useEffect(() => {
    fetchSuggestion();

  }, []);


    const filteredData = Array.isArray(fetchWeb)
    ? fetchWeb.filter(itm =>
      Object.values(itm).some(val =>
        String(val).toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];

 const formatDate = (date) => {
  if (!date) return "-";

  const d = new Date(date);

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 0 to 12 for midnight
  hours = String(hours).padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
};   

  return (
      <div className="container py-4">
   
       
           <div className="border-0  mb-3 px-2 py-2  ">
           
             <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
               <div className="d-flex align-items-center">
                 <h4 className="fw-bold mb-0" style={{ fontSize: "20px" }}>
              Chatbot Suggestion
                 </h4>
               </div>
           
               {/* CENTER SEARCH */}
           <div style={{ flex: 1, maxWidth: "250px" }}>
             <div
               className="d-flex align-items-center rounded-pill overflow-hidden"
               style={{
                 border: "1px solid var(--green)",
                 height: "34px",
                 paddingLeft: "8px",
                 paddingRight: "8px",
                 backgroundColor:'white'
               }}
             >
               {/* ICON */}
               <FaSearch
                 style={{
                   color: "var(--green)",
                   fontSize: "14px",
                   display: "flex",
                   alignItems: "center"
                 }}
               />
           
               {/* INPUT */}
               <input
                 type="text"
                 className="form-control border-0 shadow-none"
                 placeholder="Search..."
                 value={searchTerm}
                 onChange={(e) => setSearchTerm(e.target.value)}
                 style={{
                   fontSize: "14px",
                   height: "32px",
                   marginLeft: "6px",
                   lineHeight: "32px"
                 }}
               />
             </div>
           </div>
           
            
           
             </div>
           </div>
   
              
   {!showForm && (
  <div className="container-fluid mt-4">
    <div className="row g-4">

      {filteredData.length > 0 ? (
        filteredData.map((item) => (
          <div className="col-xl-4 col-lg-6 col-md-6" key={item.id}>

            <div className="inventory-card d-flex flex-column h-100">

              {/* Header */}
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h5 className="fw-bold mb-1">
                    {item.cust_name}
                  </h5>

                  <span className="badge bg-primary">
                    {item.user_type}
                  </span>
                </div>

                <div className="text-end">
                  <span className="badge bg-success">
                    {item.category_name}
                  </span>
                </div>
              </div>

              <hr />

              {/* Details */}

              <div className="inventory-row">
                <span className="inventory-label">
                  Mobile
                </span>

                <span>{item.mobile}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Language
                </span>

                <span>{item.language}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Added On
                </span>

                <span>{formatDate(item.added_on)}</span>
              </div>

              <div className="inventory-row">
                <span className="inventory-label">
                  Category
                </span>

                <span>{item.category_name}</span>
              </div>

              <div className="mt-3">
                <small className="text-muted fw-semibold">
                 Question
                </small>

                <div
                  className="mt-1 p-2 rounded"
                  style={{
                    background: "#dee2e6",
                    minHeight: "70px",
                  }}
                >
                  {item.description || "No Description"}
                </div>
              </div>

            </div>

          </div>
        ))
      ) : (
        <div className="col-12">
          <div className="alert alert-light text-center shadow-sm rounded-4">
            No Data Found
          </div>
        </div>
      )}

    </div>
  </div>
)}

   
   
      </div>
  )
}

export default Chatbot_Suggestion
